export function createSupportCaseClient(transport) {
    return {
        /**
         * POST /internal/v1/tenants/{tenantId}/support-cases
         *
         * Requires scope: support-cases:create
         */
        createSupportCase(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/support-cases`,
                body,
                options,
            });
        },
        /**
         * GET /internal/v1/tenants/{tenantId}/support-cases/{id}
         *
         * Requires scope: support-cases:read
         */
        getSupportCase(tenantId, id, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/support-cases/${encodeURIComponent(id)}`,
                options,
            });
        },
        /**
         * List the support cases this caller may see
         *
         * Requires scope: support-cases:read
         */
        listSupportCases(tenantId, limit, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/support-cases`,
                query: { limit: limit },
                options,
            });
        },
        /**
         * Read one support case, as its customer or as an agent
         *
         * Requires scope: support-cases:read
         */
        getSupportCase2(tenantId, id, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/support-cases/${encodeURIComponent(id)}`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/support-cases/{id}/transitions
         *
         * Requires scope: support-cases:agent, support-cases:transition
         */
        transitionSupportCase(tenantId, id, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/support-cases/${encodeURIComponent(id)}/transitions`,
                body,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/support-cases/{id}/sensitive-notes
         *
         * Requires scope: support-cases:agent, support-cases:sensitive-note
         */
        addSensitiveCaseNote(tenantId, id, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/support-cases/${encodeURIComponent(id)}/sensitive-notes`,
                body,
                options,
            });
        },
        /**
         * How this tenant's support agents were rated
         *
         * Requires scope: support-satisfaction:read
         */
        listAgentSatisfaction(tenantId, limit, after, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/support-satisfaction`,
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * Record a customer's rating of a closed case
         *
         * Requires scope: support-satisfaction:submit
         */
        rateSupportCase(tenantId, id, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/support-cases/${encodeURIComponent(id)}/satisfaction`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=support-case.js.map